export const getLabel = {
  service: 'Service',
  efficiency: 'Efficiency',
  employeeBehavioural: 'EI Behavioral',
  cleanliness: 'Cleanliness',
  product: 'Product',
  salesOpportunity: 'Sales Opportunity',
  food: 'Food Quality',
  sustainability: 'Sustainability',
};

export function translatePerformanceClassificationLabel (type) {
  return getLabel[type] || type;
}
